import script from "./Test.vue?vue&type=script&setup=true&lang=ts"
export * from "./Test.vue?vue&type=script&setup=true&lang=ts"

import "./Test.vue?vue&type=style&index=0&id=24a04bba&lang=css"

const __exports__ = script;

export default __exports__